// Import all card images
import seedImg from './assets/seed.png';
import saplingImg from './assets/sapling.png';
import treeImg from './assets/tree.png';
import batteryImg from './assets/battery.png';
import bloomImg from './assets/bloom.png';
import engineerImg from './assets/engineer.png';
import explorerImg from './assets/explorer.png';
import factoryImg from './assets/factory.png';
import forestImg from './assets/forest.png';
import gardenImg from './assets/garden.png';
import loveImg from './assets/love.png';
import materialsImg from './assets/materials.png';
import meditationImg from './assets/meditation.png';
import naturalistImg from './assets/naturalist2.png';
import observationImg from './assets/observation.png';
import patienceImg from './assets/patience.png';
import settlementImg from './assets/settlement.png';
import solarPanelImg from './assets/solar.png';
import thrivingCivilizationImg from './assets/thrivingCivilization.png';
import thrivingEcosystemImg from './assets/thrivingEcosystem.png';
import toolsImg from './assets/tools.png';
import wildflowersImg from './assets/wildflowers.png';
import windTurbineImg from './assets/windturbine2.png';
import habitatImg from './assets/habitat.png';
import oasisImg from './assets/oasis.png';
import communityImg from './assets/community.png';
import curiosityImg from './assets/curiosity.png';
import scavengerImg from './assets/scavenger.png';
import futuristImg from './assets/futurist.png';
import farmImg from './assets/farm.png';
import nuclearImg from './assets/nuclear.png';
import physicistImg from './assets/physicist.png';
import unchartedImg from './assets/uncharted.png';
import cityImg from './assets/city.png';
import thrivingSpiritImg from './assets/thrivingSpirit.png';
import recycleImg from './assets/recycle.png';
import libraryImg from './assets/library.png';

export const CARD_IDS = {
  // Wisdom cards
  MEDITATION: 'w-1',
  PATIENCE: 'w-2',
  LOVE: 'w-3',
  CURIOSITY: 'w-4',
  ENGINEER: 'w-5',
  PHYSICIST: 'w-6',
  NATURALIST: 'w-7',
  OBSERVATION: 'w-8',
  EXPLORER: 'w-9',
  SCAVENGER: 'w-10',
  FUTURIST: 'w-11',
  COMMUNITY: 'w-12',
  THRIVING_SPIRIT: 'w-13',
  LIBRARY: 'w-14',
  
  
  // Eco cards
  SEED: 'e-1',
  SAPLING: 'e-2',
  TREE: 'e-3',
  FOREST: 'e-4',
  GARDEN: 'e-5',
  FARM: 'e-6',
  HABITAT: 'e-7',
  OASIS: 'e-10',
  BLOOM: 'e-11',
  THRIVING_ECOSYSTEM: 'e-12',
  UNCHARTED: 'e-13',
  WILDFLOWERS: 'e-14',
  
  // Tech cards
  MATERIALS: 't-1',
  TOOLS: 't-2',
  BATTERY: 't-3',
  SOLAR_PANEL: 't-4',
  WIND_TURBINE: 't-5',
  NUCLEAR_ENERGY: 't-6',
  SETTLEMENT: 't-7',
  FACTORY: 't-8',
  THRIVING_CIVILIZATION: 't-9',
  CITY: 't-10',
  RECYCLE: 't-11',
};

export const CARD_RARITY = {
  COMMON: 'common', // Default 3 copies max
  SPECIAL: 'special' // Only 1 copy allowed
};

// Available cards for deck building
export const availableCards = [
  // Wisdom cards
  {
    id: CARD_IDS.LIBRARY,
    name: 'Library',
    type: 'Wisdom',
    energy: 2,
    imageUrl: libraryImg, // You'll need to add this image
    description: 'Add a wisdom card from your deck. bonus for each Curiosity card played.',
    rarity: CARD_RARITY.COMMON
  },
   {id: CARD_IDS.MEDITATION , name: 'Meditation', type: 'Wisdom', energy: 3, imageUrl: meditationImg, description: '+3 energy', rarity: CARD_RARITY.COMMON},
 {id: CARD_IDS.PATIENCE, name: 'Patience', type: 'Wisdom', energy: 1, imageUrl: patienceImg, description: '+1 energy. Requires meditation', rarity: CARD_RARITY.COMMON},
	{id: CARD_IDS.LOVE, name: 'Love', type: 'Wisdom', energy: 5, imageUrl: loveImg, description: '+5 energy, +1 space. Requires patience.', rarity: CARD_RARITY.COMMON},
   {id: CARD_IDS.CURIOSITY, name: 'Curiosity', type: 'Wisdom', energy: 2, imageUrl: curiosityImg, description: '+2 energy', rarity: CARD_RARITY.COMMON },
   {id: CARD_IDS.ENGINEER, name: 'Engineer', type: 'Wisdom', energy: 0, imageUrl: engineerImg, description: 'Build advanced technology.', rarity: CARD_RARITY.COMMON },
   {id: CARD_IDS.PHYSICIST, name: 'Physicist', type: 'Wisdom', energy: 0, imageUrl: physicistImg, description: 'Build advanced technology. Requires curiosity.', rarity: CARD_RARITY.COMMON },
   {id: CARD_IDS.NATURALIST, name: 'Naturalist', type: 'Wisdom', energy: 0, imageUrl: naturalistImg, rarity: CARD_RARITY.COMMON },
   {id: CARD_IDS.OBSERVATION, name: 'Observation', type: 'Wisdom', energy: 0, imageUrl: observationImg, description: 'Draw 2 cards.', rarity: CARD_RARITY.COMMON },
   {id: CARD_IDS.COMMUNITY, name: 'Community', type: 'Wisdom', energy: 5, imageUrl: communityImg, description: '+5 energy, +2 spaces, +1 hand. Requires garden or love.', rarity: CARD_RARITY.COMMON },
  
   {id: CARD_IDS.EXPLORER, name: 'Explorer', type: 'Wisdom', energy: -5, imageUrl: explorerImg, description: '-5 energy, draw 3 cards. Requires curiosity.', rarity: CARD_RARITY.COMMON},
   
   {id: CARD_IDS.SCAVENGER, name: 'Scavenger', type: 'Wisdom', energy: 0, imageUrl: scavengerImg, description: 'Move two cards from the discard pile into your hand.', rarity: CARD_RARITY.COMMON },
   
   {id: CARD_IDS.RECYCLE,
     name: 'Recycle',
     type: 'Tech',
     energy: -5,
     imageUrl: recycleImg,
     description: '-5 energy. Choose technology cards from discard to recycle. Get a materials card for each. Requires energy source and scavenger.', rarity: CARD_RARITY.COMMON
   },
   {id: CARD_IDS.FUTURIST, name: 'Futurist', type: 'Wisdom', energy: 0, imageUrl: futuristImg, description: 'Select a card from your deck and put it into your hand.', rarity: CARD_RARITY.COMMON },
   { id: CARD_IDS.THRIVING_SPIRIT,
	   name: 'Thriving Spirit', 
	   type: 'Wisdom', 
	   energy: 0, 
	   imageUrl: thrivingSpiritImg, 
	   description: 'Pick 2 cards from discard pile and 2 from deck. +1 space. Requires curiosity and love.', rarity: CARD_RARITY.SPECIAL
	 },
  
  // Ecology cards
   {id: CARD_IDS.SEED, name: 'Seed', type: 'Eco', energy: 0, imageUrl: seedImg, rarity: CARD_RARITY.COMMON},
   {id: CARD_IDS.SAPLING, name: 'Sapling', type: 'Eco', energy: 1, imageUrl: saplingImg, description: '+1 energy, Requires seed', rarity: CARD_RARITY.COMMON },
   {id: CARD_IDS.TREE, name: 'Tree', type: 'Eco', energy: 3, imageUrl: treeImg, description: '+3 energy. Requires sapling or seed and patience.', rarity: CARD_RARITY.COMMON },
   {id: CARD_IDS.FOREST, name: 'Forest', type: 'Eco', energy: 10, imageUrl: forestImg, description: '+10 energy. Requires tree.', rarity: CARD_RARITY.COMMON},
   {id: CARD_IDS.GARDEN, name: 'Garden', type: 'Eco', energy: 5, imageUrl: gardenImg, description: '+5 energy. Requires naturalist and seed or seed and patience.', rarity: CARD_RARITY.COMMON },
   {id: CARD_IDS.FARM, name: 'Farm', type: 'Eco', energy: 7, imageUrl: farmImg, description: '+7 energy. Requires Community.', rarity: CARD_RARITY.COMMON },
   {id: CARD_IDS.HABITAT, name: 'Habitat', type: 'Eco', energy: 1, imageUrl: habitatImg, description: '+1 energy +2 spaces. Requires naturalist or forest.', rarity: CARD_RARITY.COMMON },
   {id: CARD_IDS.OASIS, name: 'Oasis', type: 'Eco', energy: 5, imageUrl: oasisImg, description: '+5 energy, + 3 spaces. Requires Explorer with patience or naturalist.', rarity: CARD_RARITY.COMMON },
   {id: CARD_IDS.BLOOM, name: 'Bloom', type: 'Eco', energy: 0, imageUrl: bloomImg, description: 'Adds a sapling, tree, forest, and wildflowers to deck. Requires tree', rarity: CARD_RARITY.COMMON},
   {id: CARD_IDS.WILDFLOWERS, name: 'Wildflowers', type: 'Eco', energy: 5, imageUrl: wildflowersImg, description: '+5 energy', rarity: CARD_RARITY.COMMON},
   {id: CARD_IDS.THRIVING_ECOSYSTEM, name: 'Thriving Ecosystem', type: 'Eco', energy: 15, imageUrl: thrivingEcosystemImg, description: '+15 energy. Requires forest and love. Adds bloom card to deck.', rarity: CARD_RARITY.SPECIAL},
   {id: CARD_IDS.UNCHARTED, name: 'Uncharted', type: 'Eco', energy: 0, imageUrl: unchartedImg, description: '+2 spaces. Adds 2 random cards to the deck. Requires explorer.', rarity: CARD_RARITY.COMMON },
   // Technology cards
   {id: CARD_IDS.MATERIALS, name: 'Materials', type: 'Tech', energy: -5, imageUrl: materialsImg, description: '-5 energy. Required to build', rarity: CARD_RARITY.COMMON },
   {id: CARD_IDS.TOOLS, name: 'Tools', type: 'Tech', energy: 0, imageUrl: toolsImg, description: 'Required to build', rarity: CARD_RARITY.COMMON },
   {id: CARD_IDS.BATTERY, name: 'Battery', type: 'Tech', energy: 0, imageUrl: batteryImg, description: 'Requires materials and tools', rarity: CARD_RARITY.COMMON },
   {id: CARD_IDS.SOLAR_PANEL, name: 'Solar Panel', type: 'Tech', energy: 7, imageUrl: solarPanelImg, description: '+7 energy. Requires battery and engineer', rarity: CARD_RARITY.COMMON },
   {id: CARD_IDS.WIND_TURBINE, name: 'Wind Turbine', type: 'Tech', energy: 5, imageUrl: windTurbineImg, description: '+5 energy. Requires battery and engineer', rarity: CARD_RARITY.COMMON},
   {id: CARD_IDS.NUCLEAR_ENERGY, name: 'Nuclear Energy', type: 'Tech', energy: 10, imageUrl: nuclearImg, description: '+10 energy. Requires battery, engineer, and physicist', rarity: CARD_RARITY.COMMON},
   {id: CARD_IDS.SETTLEMENT, name: 'Settlement', type: 'Tech', energy: -5, imageUrl: settlementImg, description: '-5 energy, +5 spaces. Requires energy source or farm.', rarity: CARD_RARITY.COMMON},
   {id: CARD_IDS.FACTORY, name: 'Factory', type: 'Tech', energy: -10, imageUrl: factoryImg, description: '-10 energy. Build 3 cards for every material card played. Requires Settlement', rarity: CARD_RARITY.COMMON},
   { id: CARD_IDS.CITY,
	   name: 'City', 
	   type: 'Tech', 
	   energy: 0, 
	   imageUrl: cityImg, 
	   description: '+5 spaces. Requires factory, community or settlement, and 2 different energy sources.', rarity: CARD_RARITY.COMMON
	 },
   {id: CARD_IDS.THRIVING_CIVILIZATION, name: 'Thriving Civilization', type: 'Tech', energy: 0, imageUrl: thrivingCivilizationImg, description: ' +10 spaces. Adds a factory and city to deck. Requires city and love.', rarity: CARD_RARITY.SPECIAL },
   
];

// Add error handling to card lookup
export const cardLookup = new Map(availableCards.map(card => {
  if (!card.id) {
    console.error(`Card missing ID: ${card.name}`);
  }
  return [card.id, card];
}));



export const defaultDeck = [
  // Wisdom cards
   CARD_IDS.ENGINEER,
   CARD_IDS.ENGINEER,
   CARD_IDS.MEDITATION,
   CARD_IDS.MEDITATION,
   CARD_IDS.CURIOSITY,
   CARD_IDS.CURIOSITY,
   CARD_IDS.OBSERVATION,
   CARD_IDS.OBSERVATION,
   CARD_IDS.NATURALIST,
   CARD_IDS.NATURALIST,
   CARD_IDS.EXPLORER,
   CARD_IDS.PATIENCE,
   CARD_IDS.PATIENCE,
   CARD_IDS.LOVE,
   CARD_IDS.SCAVENGER,
   CARD_IDS.FUTURIST,
   CARD_IDS.PHYSICIST,
  CARD_IDS.UNCHARTED,
   CARD_IDS.THRIVING_SPIRIT,
 // Ecology cards
   CARD_IDS.SEED,
   CARD_IDS.SEED,
   CARD_IDS.SEED,
   CARD_IDS.SAPLING,
   CARD_IDS.SAPLING,
   CARD_IDS.SAPLING,
   CARD_IDS.TREE,
   CARD_IDS.TREE,
   CARD_IDS.TREE,
   CARD_IDS.FOREST,
   CARD_IDS.FOREST,
   CARD_IDS.FOREST,
   CARD_IDS.GARDEN,
   CARD_IDS.GARDEN,
   CARD_IDS.FARM,
   CARD_IDS.FARM,
   CARD_IDS.COMMUNITY,
   CARD_IDS.HABITAT,
   CARD_IDS.HABITAT,
   CARD_IDS.OASIS,
   CARD_IDS.BLOOM,
   CARD_IDS.BLOOM,
   CARD_IDS.THRIVING_ECOSYSTEM,
   // Technology cards
   CARD_IDS.MATERIALS,
   CARD_IDS.MATERIALS,
   CARD_IDS.MATERIALS,
   CARD_IDS.TOOLS,
   CARD_IDS.TOOLS,
   CARD_IDS.TOOLS,
   CARD_IDS.BATTERY,
   CARD_IDS.BATTERY,
   CARD_IDS.BATTERY,
   CARD_IDS.SOLAR_PANEL,
   CARD_IDS.SOLAR_PANEL,
   CARD_IDS.WIND_TURBINE,
   CARD_IDS.NUCLEAR_ENERGY,
   CARD_IDS.RECYCLE,
   CARD_IDS.SETTLEMENT,
   CARD_IDS.FACTORY,
   CARD_IDS.CITY,
   CARD_IDS.THRIVING_CIVILIZATION,
   
];

const convertOldDeckFormat = (oldDeck) => {
  if (!Array.isArray(oldDeck)) return null;
  
  // Check if deck is already in ID format
  if (typeof oldDeck[0] === 'string') return oldDeck;
  
  return oldDeck.map(oldCard => {
    const matchingCard = availableCards.find(card => 
      card.name === oldCard.name && 
      card.type === oldCard.type
    );
    return matchingCard ? matchingCard.id : null;
  }).filter(id => id !== null);
};

// Update loadDeck to work with IDs
// Update loadDeck with better error handling
export const loadDeck = () => {
  const activeDeckName = localStorage.getItem('activeDeck');
  
  if (!activeDeckName || activeDeckName === 'Starter Deck') {
    const defaultCards = defaultDeck.map(id => {
      const card = cardLookup.get(id);
      if (!card) {
        console.error(`Invalid card ID in default deck: ${id}`);
      }
      return card;
    }).filter(Boolean);

    if (defaultCards.length === 0) {
      console.error('No valid cards found in default deck');
    }
    return defaultCards;
  }

  try {
    const savedDeck = localStorage.getItem('customDeck');
    if (!savedDeck) {
      return defaultDeck.map(id => cardLookup.get(id)).filter(Boolean);
    }

    const parsedDeck = JSON.parse(savedDeck);
    const idDeck = convertOldDeckFormat(parsedDeck);
    
    if (!idDeck) {
      console.warn('Invalid deck format found, resetting to default deck');
      localStorage.setItem('activeDeck', 'Starter Deck');
      localStorage.removeItem('customDeck');
      return defaultDeck.map(id => cardLookup.get(id)).filter(Boolean);
    }

    const validatedDeck = idDeck.map(id => {
      const card = cardLookup.get(id);
      if (!card) {
        console.error(`Invalid card ID in saved deck: ${id}`);
      }
      return card;
    }).filter(Boolean);

    if (validatedDeck.length < DECK_CONSTRAINTS.MIN_CARDS) {
      console.warn('Deck contains insufficient valid cards, resetting to default deck');
      localStorage.setItem('activeDeck', 'Starter Deck');
      localStorage.removeItem('customDeck');
      return defaultDeck.map(id => cardLookup.get(id)).filter(Boolean);
    }

    return validatedDeck;
  } catch (error) {
    console.error('Error loading deck:', error);
    return defaultDeck.map(id => cardLookup.get(id)).filter(Boolean);
  }
};

// Add error checking to card addition
export const canAddCardToDeck = (deck, cardId) => {
  const card = cardLookup.get(cardId);
  if (!card) {
    console.error(`Attempted to add invalid card ID: ${cardId}`);
    return false;
  }

  const currentCount = deck.filter(id => id === cardId).length;
  const maxAllowed = card.rarity === CARD_RARITY.SPECIAL ? 1 : DECK_CONSTRAINTS.MAX_COPIES;

  return currentCount < maxAllowed && deck.length < DECK_CONSTRAINTS.MAX_CARDS;
};

export const saveDeck = (deckName, deck) => {
  // Convert full cards to IDs before saving
  const deckIds = deck.map(card => card.id);
  
  if (deckName === 'Starter Deck') {
    console.warn('Cannot save over Starter Deck');
    return false;
  }

  try {
    const savedDecks = JSON.parse(localStorage.getItem('savedDecks') || '{}');
    savedDecks[deckName] = deckIds;
    localStorage.setItem('savedDecks', JSON.stringify(savedDecks));
    return true;
  } catch (error) {
    console.error('Error saving deck:', error);
    return false;
  }
};
// eslint-disable-next-line no-unused-vars
const isValidCard = (card) => {
  return (
    card &&
    typeof card === 'object' &&
    typeof card.name === 'string' &&
    typeof card.type === 'string' &&
    typeof card.energy === 'number' &&
    typeof card.imageUrl === 'string' &&
    ['Wisdom', 'Eco', 'Tech'].includes(card.type)
  );
};

// Add card type constants for better maintainability
export const CARD_TYPES = {
  WISDOM: 'Wisdom',
  ECO: 'Eco',
  TECH: 'Tech'
};

// Add deck constants
export const DECK_CONSTRAINTS = {
  MIN_CARDS: 40,
  MAX_CARDS: 60,
  MAX_COPIES: 3 // Maximum copies of a single card allowed
};

// Add getDeckWarnings function
export const getDeckWarnings = (deck) => {
  const warnings = [];
  const cardCounts = new Map();

  // Check card counts and special cards
  deck.forEach(cardId => {
    const card = cardLookup.get(cardId);
    if (!card) {
      warnings.push(`Invalid card found in deck`);
      return;
    }

    const count = (cardCounts.get(cardId) || 0) + 1;
    cardCounts.set(cardId, count);

    const maxAllowed = card.rarity === CARD_RARITY.SPECIAL ? 1 : DECK_CONSTRAINTS.MAX_COPIES;
    if (count > maxAllowed) {
      warnings.push(`Too many copies of ${card.name} (max ${maxAllowed})`);
    }
  });

  // Check deck size
  if (deck.length < DECK_CONSTRAINTS.MIN_CARDS) {
    warnings.push(`Deck needs at least ${DECK_CONSTRAINTS.MIN_CARDS} cards (currently ${deck.length})`);
  }
  if (deck.length > DECK_CONSTRAINTS.MAX_CARDS) {
    warnings.push(`Deck cannot have more than ${DECK_CONSTRAINTS.MAX_CARDS} cards (currently ${deck.length})`);
  }


  return warnings;
};

export const validateDeck = (deck) => {
  const warnings = getDeckWarnings(deck);
  
  if (warnings.length > 0) {
    return {
      valid: false,
      error: warnings[0] // Return first warning as main error
    };
  }

  return { valid: true };
};

// Helper function to get deck statistics
export const getDeckStats = (deck) => {
  const stats = {
    totalCards: deck.length,
    typeDistribution: {
      [CARD_TYPES.WISDOM]: 0,
      [CARD_TYPES.ECO]: 0,
      [CARD_TYPES.TECH]: 0
    },
    energyProfile: {
      total: 0,
      positive: 0,
      negative: 0,
      neutral: 0
    },
    cardCounts: new Map()
  };

  for (const card of deck) {
    // Count card types
    stats.typeDistribution[card.type]++;

    // Track energy profile
    stats.energyProfile.total += card.energy;
    if (card.energy > 0) stats.energyProfile.positive++;
    else if (card.energy < 0) stats.energyProfile.negative++;
    else stats.energyProfile.neutral++;

    // Track individual card counts
    const count = stats.cardCounts.get(card.name) || 0;
    stats.cardCounts.set(card.name, count + 1);
  }

  return stats;
};

// Function to check if a deck is playable (has necessary base cards)
export const isDeckPlayable = (deck) => {
  const hasCard = (cardName) => deck.some(card => card.name === cardName);
  
  // Check for essential base cards
  const hasEssentialCards = {
    // Check for basic resources
    hasSeed: hasCard('Seed'),
    hasMaterials: hasCard('Materials'),
    
    // Check for base Wisdom cards
    hasMeditation: hasCard('Meditation'),
    hasCuriosity: hasCard('Curiosity'),
    
    // Check for basic Tech
    hasTools: hasCard('Tools'),
    
    // Check for at least one type of energy generation
    hasEnergyGeneration: hasCard('Tree') || hasCard('Solar Panel') || hasCard('Wind Turbine') || hasCard('Nuclear Energy') || hasCard('Forest'),
  };
  
  // Check if the deck has enough energy generation
  const hasPositiveEnergy = deck.filter(card => card.energy > 0).length > 0;
  
  // Calculate minimum requirements
  const meetsMinimumRequirements = 
    hasEssentialCards.hasSeed && 
    hasEssentialCards.hasMaterials && 
    (hasEssentialCards.hasMeditation || hasEssentialCards.hasCuriosity) &&
    hasPositiveEnergy;
  
  return { 
    playable: meetsMinimumRequirements,
    missingRequirements: Object.entries(hasEssentialCards)
      .filter(([_, value]) => !value)
      .map(([key]) => key.replace('has', ''))
  };
};

// Utility function to shuffle deck
export const shuffleDeck = (deck) => {
  let shuffledDeck = [...deck];
  for (let i = shuffledDeck.length - 1; i > 0; i--) {
	const j = Math.floor(Math.random() * (i + 1));
	[shuffledDeck[i], shuffledDeck[j]] = [shuffledDeck[j], shuffledDeck[i]];
  }
  return shuffledDeck;
};

// Card style for rendering
export const cardStyle = {
  width: '20vw',
  color: 'black',
  backgroundColor: 'rgba(255,255,255,0.95)',
  borderRadius: '10px',
  boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.15)',
  display: 'inline-block',
  padding: '2.5px',
  margin: '5px',
  textAlign: 'center',
  verticalAlign: 'top',
  overflow: 'hidden',
  position: 'relative',
  boxSizing: 'border-box',
  animation: 'fadeIn 1s ease-out',
  opacity: 1,
};

export const deckCardStyle = {
  width: '25vw',
  color: 'black',
  backgroundColor: 'rgba(255,255,255,0.95)',
  borderRadius: '10px',
  boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.15)',
  display: 'inline-block',
  padding: '2.5px',
  margin: '5px',
  textAlign: 'center',
  verticalAlign: 'top',
  overflow: 'hidden',
  position: 'relative',
  boxSizing: 'border-box',
};

export const cardDetailStyle = {
  width: '75vw',
  color: 'black',
  backgroundColor: 'transparent',
  borderRadius: '10px',
  display: 'inline-block',
  padding: '2.5px',
  margin: '5px',
  textAlign: 'center',
  verticalAlign: 'top',
  overflow: 'hidden',
  position: 'relative',
  boxSizing: 'border-box',
};

// ============================================
// AI DECK CONFIGURATIONS
// All decks follow rules: 40-60 cards, max 3 common copies, max 1 special copy
// Special cards: Thriving Spirit, Thriving Ecosystem, Thriving Civilization
// ============================================

// Standard Starter Deck - available at all difficulties
const STANDARD_DECK = {
  name: 'Starter Deck',
  description: 'The balanced default deck',
  cards: [...defaultDeck] // Uses the same default deck as players
};

// EASY AI Decks (40 cards each) - Simple strategies, fewer synergies
export const AI_DECKS_EASY = [
  STANDARD_DECK,
  {
    name: 'Nature Basics',
    description: 'Simple eco-focused deck',
    cards: [
      // Eco chain (18 cards)
      CARD_IDS.SEED, CARD_IDS.SEED, CARD_IDS.SEED,
      CARD_IDS.SAPLING, CARD_IDS.SAPLING, CARD_IDS.SAPLING,
      CARD_IDS.TREE, CARD_IDS.TREE, CARD_IDS.TREE,
      CARD_IDS.FOREST, CARD_IDS.FOREST, CARD_IDS.FOREST,
      CARD_IDS.GARDEN, CARD_IDS.GARDEN,
      CARD_IDS.WILDFLOWERS, CARD_IDS.WILDFLOWERS,
      CARD_IDS.HABITAT, CARD_IDS.HABITAT,
      // Wisdom (12 cards)
      CARD_IDS.MEDITATION, CARD_IDS.MEDITATION, CARD_IDS.MEDITATION,
      CARD_IDS.PATIENCE, CARD_IDS.PATIENCE,
      CARD_IDS.NATURALIST, CARD_IDS.NATURALIST, CARD_IDS.NATURALIST,
      CARD_IDS.OBSERVATION, CARD_IDS.OBSERVATION,
      CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY,
      // Tech (10 cards)
      CARD_IDS.MATERIALS, CARD_IDS.MATERIALS, CARD_IDS.MATERIALS,
      CARD_IDS.TOOLS, CARD_IDS.TOOLS, CARD_IDS.TOOLS,
      CARD_IDS.BATTERY, CARD_IDS.BATTERY,
      CARD_IDS.SOLAR_PANEL, CARD_IDS.SOLAR_PANEL,
    ]
  },
  {
    name: 'Tech Starter',
    description: 'Basic technology deck',
    cards: [
      // Tech chain (18 cards)
      CARD_IDS.MATERIALS, CARD_IDS.MATERIALS, CARD_IDS.MATERIALS,
      CARD_IDS.TOOLS, CARD_IDS.TOOLS, CARD_IDS.TOOLS,
      CARD_IDS.BATTERY, CARD_IDS.BATTERY, CARD_IDS.BATTERY,
      CARD_IDS.SOLAR_PANEL, CARD_IDS.SOLAR_PANEL, CARD_IDS.SOLAR_PANEL,
      CARD_IDS.WIND_TURBINE, CARD_IDS.WIND_TURBINE, CARD_IDS.WIND_TURBINE,
      CARD_IDS.SETTLEMENT, CARD_IDS.SETTLEMENT,
      CARD_IDS.FACTORY,
      // Wisdom (12 cards)
      CARD_IDS.ENGINEER, CARD_IDS.ENGINEER, CARD_IDS.ENGINEER,
      CARD_IDS.MEDITATION, CARD_IDS.MEDITATION, CARD_IDS.MEDITATION,
      CARD_IDS.OBSERVATION, CARD_IDS.OBSERVATION,
      CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY,
      CARD_IDS.PATIENCE,
      // Eco (10 cards)
      CARD_IDS.SEED, CARD_IDS.SEED, CARD_IDS.SEED,
      CARD_IDS.SAPLING, CARD_IDS.SAPLING, CARD_IDS.SAPLING,
      CARD_IDS.TREE, CARD_IDS.TREE,
      CARD_IDS.FOREST, CARD_IDS.FOREST,
    ]
  },
  {
    name: 'Peaceful Growth',
    description: 'Meditation and patience focused',
    cards: [
      // Wisdom chain (16 cards)
      CARD_IDS.MEDITATION, CARD_IDS.MEDITATION, CARD_IDS.MEDITATION,
      CARD_IDS.PATIENCE, CARD_IDS.PATIENCE, CARD_IDS.PATIENCE,
      CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY,
      CARD_IDS.OBSERVATION, CARD_IDS.OBSERVATION, CARD_IDS.OBSERVATION,
      CARD_IDS.NATURALIST, CARD_IDS.NATURALIST,
      CARD_IDS.LOVE, CARD_IDS.LOVE,
      // Eco (14 cards)
      CARD_IDS.SEED, CARD_IDS.SEED, CARD_IDS.SEED,
      CARD_IDS.SAPLING, CARD_IDS.SAPLING, CARD_IDS.SAPLING,
      CARD_IDS.TREE, CARD_IDS.TREE, CARD_IDS.TREE,
      CARD_IDS.GARDEN, CARD_IDS.GARDEN, CARD_IDS.GARDEN,
      CARD_IDS.FOREST, CARD_IDS.FOREST,
      // Tech (10 cards)
      CARD_IDS.MATERIALS, CARD_IDS.MATERIALS, CARD_IDS.MATERIALS,
      CARD_IDS.TOOLS, CARD_IDS.TOOLS, CARD_IDS.TOOLS,
      CARD_IDS.BATTERY, CARD_IDS.BATTERY,
      CARD_IDS.SOLAR_PANEL, CARD_IDS.SOLAR_PANEL,
    ]
  }
];

// MEDIUM AI Decks (40-45 cards) - Balanced strategies with synergies
export const AI_DECKS_MEDIUM = [
  STANDARD_DECK,
  {
    name: 'Eco Engine',
    description: 'Strong eco chain with bloom synergy',
    cards: [
      // Eco chain (19 cards)
      CARD_IDS.SEED, CARD_IDS.SEED, CARD_IDS.SEED,
      CARD_IDS.SAPLING, CARD_IDS.SAPLING, CARD_IDS.SAPLING,
      CARD_IDS.TREE, CARD_IDS.TREE, CARD_IDS.TREE,
      CARD_IDS.FOREST, CARD_IDS.FOREST, CARD_IDS.FOREST,
      CARD_IDS.BLOOM, CARD_IDS.BLOOM, CARD_IDS.BLOOM,
      CARD_IDS.HABITAT, CARD_IDS.HABITAT,
      CARD_IDS.GARDEN, CARD_IDS.GARDEN,
      // Wisdom (13 cards)
      CARD_IDS.MEDITATION, CARD_IDS.MEDITATION, CARD_IDS.MEDITATION,
      CARD_IDS.PATIENCE, CARD_IDS.PATIENCE, CARD_IDS.PATIENCE,
      CARD_IDS.NATURALIST, CARD_IDS.NATURALIST, CARD_IDS.NATURALIST,
      CARD_IDS.LOVE, CARD_IDS.LOVE,
      CARD_IDS.OBSERVATION, CARD_IDS.OBSERVATION,
      // Tech (10 cards)
      CARD_IDS.MATERIALS, CARD_IDS.MATERIALS, CARD_IDS.MATERIALS,
      CARD_IDS.TOOLS, CARD_IDS.TOOLS, CARD_IDS.TOOLS,
      CARD_IDS.BATTERY, CARD_IDS.BATTERY,
      CARD_IDS.SOLAR_PANEL, CARD_IDS.SOLAR_PANEL,
    ]
  },
  {
    name: 'Power Grid',
    description: 'Energy production focused',
    cards: [
      // Tech chain (20 cards)
      CARD_IDS.MATERIALS, CARD_IDS.MATERIALS, CARD_IDS.MATERIALS,
      CARD_IDS.TOOLS, CARD_IDS.TOOLS, CARD_IDS.TOOLS,
      CARD_IDS.BATTERY, CARD_IDS.BATTERY, CARD_IDS.BATTERY,
      CARD_IDS.SOLAR_PANEL, CARD_IDS.SOLAR_PANEL, CARD_IDS.SOLAR_PANEL,
      CARD_IDS.WIND_TURBINE, CARD_IDS.WIND_TURBINE, CARD_IDS.WIND_TURBINE,
      CARD_IDS.NUCLEAR_ENERGY, CARD_IDS.NUCLEAR_ENERGY,
      CARD_IDS.SETTLEMENT, CARD_IDS.SETTLEMENT,
      CARD_IDS.FACTORY,
      // Wisdom (12 cards)
      CARD_IDS.ENGINEER, CARD_IDS.ENGINEER, CARD_IDS.ENGINEER,
      CARD_IDS.PHYSICIST, CARD_IDS.PHYSICIST,
      CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY,
      CARD_IDS.MEDITATION, CARD_IDS.MEDITATION,
      CARD_IDS.OBSERVATION, CARD_IDS.OBSERVATION,
      // Eco (10 cards)
      CARD_IDS.SEED, CARD_IDS.SEED, CARD_IDS.SEED,
      CARD_IDS.SAPLING, CARD_IDS.SAPLING,
      CARD_IDS.TREE, CARD_IDS.TREE, CARD_IDS.TREE,
      CARD_IDS.FOREST, CARD_IDS.FOREST,
    ]
  },
  {
    name: 'Community Builder',
    description: 'Space generation and community synergy',
    cards: [
      // Wisdom/Community (16 cards)
      CARD_IDS.MEDITATION, CARD_IDS.MEDITATION, CARD_IDS.MEDITATION,
      CARD_IDS.PATIENCE, CARD_IDS.PATIENCE, CARD_IDS.PATIENCE,
      CARD_IDS.LOVE, CARD_IDS.LOVE, CARD_IDS.LOVE,
      CARD_IDS.COMMUNITY, CARD_IDS.COMMUNITY, CARD_IDS.COMMUNITY,
      CARD_IDS.NATURALIST, CARD_IDS.NATURALIST,
      CARD_IDS.OBSERVATION, CARD_IDS.OBSERVATION,
      // Eco (14 cards)
      CARD_IDS.SEED, CARD_IDS.SEED, CARD_IDS.SEED,
      CARD_IDS.SAPLING, CARD_IDS.SAPLING, CARD_IDS.SAPLING,
      CARD_IDS.TREE, CARD_IDS.TREE,
      CARD_IDS.GARDEN, CARD_IDS.GARDEN, CARD_IDS.GARDEN,
      CARD_IDS.FOREST, CARD_IDS.FOREST,
      CARD_IDS.FARM,
      // Tech (10 cards)
      CARD_IDS.MATERIALS, CARD_IDS.MATERIALS, CARD_IDS.MATERIALS,
      CARD_IDS.TOOLS, CARD_IDS.TOOLS, CARD_IDS.TOOLS,
      CARD_IDS.BATTERY, CARD_IDS.BATTERY,
      CARD_IDS.HABITAT, CARD_IDS.HABITAT,
    ]
  },
  {
    name: 'Explorer Path',
    description: 'Card draw and exploration',
    cards: [
      // Wisdom/Draw (17 cards)
      CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY,
      CARD_IDS.EXPLORER, CARD_IDS.EXPLORER, CARD_IDS.EXPLORER,
      CARD_IDS.OBSERVATION, CARD_IDS.OBSERVATION, CARD_IDS.OBSERVATION,
      CARD_IDS.MEDITATION, CARD_IDS.MEDITATION, CARD_IDS.MEDITATION,
      CARD_IDS.PATIENCE, CARD_IDS.PATIENCE, CARD_IDS.PATIENCE,
      CARD_IDS.FUTURIST,
      CARD_IDS.NATURALIST,
      // Eco (13 cards)
      CARD_IDS.SEED, CARD_IDS.SEED, CARD_IDS.SEED,
      CARD_IDS.SAPLING, CARD_IDS.SAPLING, CARD_IDS.SAPLING,
      CARD_IDS.TREE, CARD_IDS.TREE, CARD_IDS.TREE,
      CARD_IDS.FOREST, CARD_IDS.FOREST,
      CARD_IDS.OASIS, CARD_IDS.OASIS,
      // Tech (10 cards)
      CARD_IDS.MATERIALS, CARD_IDS.MATERIALS, CARD_IDS.MATERIALS,
      CARD_IDS.TOOLS, CARD_IDS.TOOLS, CARD_IDS.TOOLS,
      CARD_IDS.BATTERY, CARD_IDS.BATTERY,
      CARD_IDS.UNCHARTED, CARD_IDS.UNCHARTED,
    ]
  }
];

// HARD AI Decks (42-48 cards) - Complex synergies with win conditions
export const AI_DECKS_HARD = [
  STANDARD_DECK,
  {
    name: 'Thriving Ecosystem',
    description: 'Aims for Thriving Ecosystem finisher',
    cards: [
      // Eco chain to Thriving Ecosystem (18 cards)
      CARD_IDS.SEED, CARD_IDS.SEED, CARD_IDS.SEED,
      CARD_IDS.SAPLING, CARD_IDS.SAPLING, CARD_IDS.SAPLING,
      CARD_IDS.TREE, CARD_IDS.TREE, CARD_IDS.TREE,
      CARD_IDS.FOREST, CARD_IDS.FOREST, CARD_IDS.FOREST,
      CARD_IDS.BLOOM, CARD_IDS.BLOOM, CARD_IDS.BLOOM,
      CARD_IDS.GARDEN, CARD_IDS.GARDEN,
      CARD_IDS.THRIVING_ECOSYSTEM, // Special - only 1 copy
      // Love chain (14 cards)
      CARD_IDS.MEDITATION, CARD_IDS.MEDITATION, CARD_IDS.MEDITATION,
      CARD_IDS.PATIENCE, CARD_IDS.PATIENCE, CARD_IDS.PATIENCE,
      CARD_IDS.LOVE, CARD_IDS.LOVE, CARD_IDS.LOVE,
      CARD_IDS.NATURALIST, CARD_IDS.NATURALIST, CARD_IDS.NATURALIST,
      CARD_IDS.OBSERVATION, CARD_IDS.OBSERVATION,
      // Support (10 cards)
      CARD_IDS.HABITAT, CARD_IDS.HABITAT, CARD_IDS.HABITAT,
      CARD_IDS.MATERIALS, CARD_IDS.MATERIALS,
      CARD_IDS.TOOLS, CARD_IDS.TOOLS,
      CARD_IDS.BATTERY, CARD_IDS.BATTERY,
      CARD_IDS.CURIOSITY,
    ]
  },
  {
    name: 'Nuclear Age',
    description: 'High-tech nuclear energy strategy',
    cards: [
      // Full tech chain (20 cards)
      CARD_IDS.MATERIALS, CARD_IDS.MATERIALS, CARD_IDS.MATERIALS,
      CARD_IDS.TOOLS, CARD_IDS.TOOLS, CARD_IDS.TOOLS,
      CARD_IDS.BATTERY, CARD_IDS.BATTERY, CARD_IDS.BATTERY,
      CARD_IDS.NUCLEAR_ENERGY, CARD_IDS.NUCLEAR_ENERGY, CARD_IDS.NUCLEAR_ENERGY,
      CARD_IDS.SOLAR_PANEL, CARD_IDS.SOLAR_PANEL,
      CARD_IDS.WIND_TURBINE, CARD_IDS.WIND_TURBINE,
      CARD_IDS.SETTLEMENT, CARD_IDS.SETTLEMENT,
      CARD_IDS.FACTORY, CARD_IDS.FACTORY,
      // Tech wisdom (14 cards)
      CARD_IDS.ENGINEER, CARD_IDS.ENGINEER, CARD_IDS.ENGINEER,
      CARD_IDS.PHYSICIST, CARD_IDS.PHYSICIST, CARD_IDS.PHYSICIST,
      CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY,
      CARD_IDS.OBSERVATION, CARD_IDS.OBSERVATION,
      CARD_IDS.SCAVENGER, CARD_IDS.SCAVENGER,
      CARD_IDS.RECYCLE,
      // Eco backup (8 cards)
      CARD_IDS.SEED, CARD_IDS.SEED, CARD_IDS.SEED,
      CARD_IDS.TREE, CARD_IDS.TREE,
      CARD_IDS.FOREST, CARD_IDS.FOREST,
      CARD_IDS.MEDITATION,
    ]
  },
  {
    name: 'Civilization Builder',
    description: 'Build towards Thriving Civilization',
    cards: [
      // City/Civ chain (20 cards)
      CARD_IDS.MATERIALS, CARD_IDS.MATERIALS, CARD_IDS.MATERIALS,
      CARD_IDS.TOOLS, CARD_IDS.TOOLS, CARD_IDS.TOOLS,
      CARD_IDS.BATTERY, CARD_IDS.BATTERY, CARD_IDS.BATTERY,
      CARD_IDS.SOLAR_PANEL, CARD_IDS.SOLAR_PANEL, CARD_IDS.SOLAR_PANEL,
      CARD_IDS.WIND_TURBINE, CARD_IDS.WIND_TURBINE,
      CARD_IDS.SETTLEMENT, CARD_IDS.SETTLEMENT, CARD_IDS.SETTLEMENT,
      CARD_IDS.FACTORY, CARD_IDS.FACTORY,
      CARD_IDS.CITY,
      CARD_IDS.THRIVING_CIVILIZATION, // Special - only 1 copy
      // Support wisdom (14 cards)
      CARD_IDS.ENGINEER, CARD_IDS.ENGINEER, CARD_IDS.ENGINEER,
      CARD_IDS.MEDITATION, CARD_IDS.MEDITATION, CARD_IDS.MEDITATION,
      CARD_IDS.PATIENCE, CARD_IDS.PATIENCE, CARD_IDS.PATIENCE,
      CARD_IDS.LOVE, CARD_IDS.LOVE,
      CARD_IDS.COMMUNITY, CARD_IDS.COMMUNITY, CARD_IDS.COMMUNITY,
      // Eco support (8 cards)
      CARD_IDS.SEED, CARD_IDS.SEED,
      CARD_IDS.TREE, CARD_IDS.TREE,
      CARD_IDS.FOREST, CARD_IDS.FOREST,
      CARD_IDS.FARM, CARD_IDS.FARM,
    ]
  },
  {
    name: 'Oasis Control',
    description: 'Explorer + Oasis space generation',
    cards: [
      // Oasis/Explorer chain (18 cards)
      CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY,
      CARD_IDS.EXPLORER, CARD_IDS.EXPLORER, CARD_IDS.EXPLORER,
      CARD_IDS.MEDITATION, CARD_IDS.MEDITATION, CARD_IDS.MEDITATION,
      CARD_IDS.PATIENCE, CARD_IDS.PATIENCE, CARD_IDS.PATIENCE,
      CARD_IDS.NATURALIST, CARD_IDS.NATURALIST, CARD_IDS.NATURALIST,
      CARD_IDS.OASIS, CARD_IDS.OASIS, CARD_IDS.OASIS,
      // Eco backup (14 cards)
      CARD_IDS.SEED, CARD_IDS.SEED, CARD_IDS.SEED,
      CARD_IDS.SAPLING, CARD_IDS.SAPLING, CARD_IDS.SAPLING,
      CARD_IDS.TREE, CARD_IDS.TREE, CARD_IDS.TREE,
      CARD_IDS.FOREST, CARD_IDS.FOREST, CARD_IDS.FOREST,
      CARD_IDS.UNCHARTED, CARD_IDS.UNCHARTED,
      // Support (10 cards)
      CARD_IDS.HABITAT, CARD_IDS.HABITAT, CARD_IDS.HABITAT,
      CARD_IDS.MATERIALS, CARD_IDS.MATERIALS,
      CARD_IDS.TOOLS, CARD_IDS.TOOLS,
      CARD_IDS.BATTERY, CARD_IDS.BATTERY,
      CARD_IDS.OBSERVATION,
    ]
  }
];

// EXPERT AI Decks (45-50 cards) - Highly optimized with multiple win conditions
export const AI_DECKS_EXPERT = [
  STANDARD_DECK,
  {
    name: 'Master Ecosystem',
    description: 'Optimized eco with Thriving Spirit combo',
    cards: [
      // Eco chain (18 cards)
      CARD_IDS.SEED, CARD_IDS.SEED, CARD_IDS.SEED,
      CARD_IDS.SAPLING, CARD_IDS.SAPLING, CARD_IDS.SAPLING,
      CARD_IDS.TREE, CARD_IDS.TREE, CARD_IDS.TREE,
      CARD_IDS.FOREST, CARD_IDS.FOREST, CARD_IDS.FOREST,
      CARD_IDS.BLOOM, CARD_IDS.BLOOM, CARD_IDS.BLOOM,
      CARD_IDS.GARDEN, CARD_IDS.GARDEN,
      CARD_IDS.THRIVING_ECOSYSTEM, // Special
      // Wisdom chain (17 cards)
      CARD_IDS.MEDITATION, CARD_IDS.MEDITATION, CARD_IDS.MEDITATION,
      CARD_IDS.PATIENCE, CARD_IDS.PATIENCE, CARD_IDS.PATIENCE,
      CARD_IDS.LOVE, CARD_IDS.LOVE, CARD_IDS.LOVE,
      CARD_IDS.NATURALIST, CARD_IDS.NATURALIST, CARD_IDS.NATURALIST,
      CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY,
      CARD_IDS.THRIVING_SPIRIT, // Special
      CARD_IDS.FUTURIST,
      // Support (10 cards)
      CARD_IDS.HABITAT, CARD_IDS.HABITAT, CARD_IDS.HABITAT,
      CARD_IDS.OBSERVATION, CARD_IDS.OBSERVATION,
      CARD_IDS.SCAVENGER, CARD_IDS.SCAVENGER,
      CARD_IDS.MATERIALS, CARD_IDS.MATERIALS,
      CARD_IDS.TOOLS,
    ]
  },
  {
    name: 'Infinite Engine',
    description: 'Factory + Recycle infinite value',
    cards: [
      // Tech engine (22 cards)
      CARD_IDS.MATERIALS, CARD_IDS.MATERIALS, CARD_IDS.MATERIALS,
      CARD_IDS.TOOLS, CARD_IDS.TOOLS, CARD_IDS.TOOLS,
      CARD_IDS.BATTERY, CARD_IDS.BATTERY, CARD_IDS.BATTERY,
      CARD_IDS.SOLAR_PANEL, CARD_IDS.SOLAR_PANEL, CARD_IDS.SOLAR_PANEL,
      CARD_IDS.WIND_TURBINE, CARD_IDS.WIND_TURBINE, CARD_IDS.WIND_TURBINE,
      CARD_IDS.SETTLEMENT, CARD_IDS.SETTLEMENT, CARD_IDS.SETTLEMENT,
      CARD_IDS.FACTORY, CARD_IDS.FACTORY, CARD_IDS.FACTORY,
      CARD_IDS.RECYCLE,
      // Support wisdom (14 cards)
      CARD_IDS.ENGINEER, CARD_IDS.ENGINEER, CARD_IDS.ENGINEER,
      CARD_IDS.SCAVENGER, CARD_IDS.SCAVENGER, CARD_IDS.SCAVENGER,
      CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY,
      CARD_IDS.OBSERVATION, CARD_IDS.OBSERVATION,
      CARD_IDS.FUTURIST,
      CARD_IDS.MEDITATION, CARD_IDS.MEDITATION,
      // Eco backup (9 cards)
      CARD_IDS.SEED, CARD_IDS.SEED, CARD_IDS.SEED,
      CARD_IDS.TREE, CARD_IDS.TREE, CARD_IDS.TREE,
      CARD_IDS.FOREST, CARD_IDS.FOREST,
      CARD_IDS.PATIENCE,
    ]
  },
  {
    name: 'Ultimate Civilization',
    description: 'Full tech tree with Thriving Civilization',
    cards: [
      // Complete tech tree (22 cards)
      CARD_IDS.MATERIALS, CARD_IDS.MATERIALS, CARD_IDS.MATERIALS,
      CARD_IDS.TOOLS, CARD_IDS.TOOLS, CARD_IDS.TOOLS,
      CARD_IDS.BATTERY, CARD_IDS.BATTERY, CARD_IDS.BATTERY,
      CARD_IDS.SOLAR_PANEL, CARD_IDS.SOLAR_PANEL, CARD_IDS.SOLAR_PANEL,
      CARD_IDS.WIND_TURBINE, CARD_IDS.WIND_TURBINE,
      CARD_IDS.NUCLEAR_ENERGY, CARD_IDS.NUCLEAR_ENERGY,
      CARD_IDS.SETTLEMENT, CARD_IDS.SETTLEMENT, CARD_IDS.SETTLEMENT,
      CARD_IDS.FACTORY, CARD_IDS.FACTORY,
      CARD_IDS.CITY,
      CARD_IDS.THRIVING_CIVILIZATION, // Special
      // Required wisdom (14 cards)
      CARD_IDS.ENGINEER, CARD_IDS.ENGINEER, CARD_IDS.ENGINEER,
      CARD_IDS.PHYSICIST, CARD_IDS.PHYSICIST, CARD_IDS.PHYSICIST,
      CARD_IDS.MEDITATION, CARD_IDS.MEDITATION, CARD_IDS.MEDITATION,
      CARD_IDS.PATIENCE, CARD_IDS.PATIENCE, CARD_IDS.PATIENCE,
      CARD_IDS.LOVE, CARD_IDS.LOVE,
      CARD_IDS.COMMUNITY,
      // Support (9 cards)
      CARD_IDS.SEED, CARD_IDS.SEED,
      CARD_IDS.TREE, CARD_IDS.TREE,
      CARD_IDS.FOREST, CARD_IDS.FOREST,
      CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY,
      CARD_IDS.FARM,
    ]
  },
  {
    name: 'Thriving Spirit Combo',
    description: 'Maximum card advantage with Thriving Spirit',
    cards: [
      // Thriving Spirit combo (18 cards)
      CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY,
      CARD_IDS.MEDITATION, CARD_IDS.MEDITATION, CARD_IDS.MEDITATION,
      CARD_IDS.PATIENCE, CARD_IDS.PATIENCE, CARD_IDS.PATIENCE,
      CARD_IDS.LOVE, CARD_IDS.LOVE, CARD_IDS.LOVE,
      CARD_IDS.THRIVING_SPIRIT, // Special
      CARD_IDS.SCAVENGER, CARD_IDS.SCAVENGER, CARD_IDS.SCAVENGER,
      CARD_IDS.FUTURIST,
      CARD_IDS.LIBRARY,
      // Strong eco payoff (15 cards)
      CARD_IDS.SEED, CARD_IDS.SEED, CARD_IDS.SEED,
      CARD_IDS.SAPLING, CARD_IDS.SAPLING, CARD_IDS.SAPLING,
      CARD_IDS.TREE, CARD_IDS.TREE, CARD_IDS.TREE,
      CARD_IDS.FOREST, CARD_IDS.FOREST, CARD_IDS.FOREST,
      CARD_IDS.NATURALIST, CARD_IDS.NATURALIST, CARD_IDS.NATURALIST,
      CARD_IDS.THRIVING_ECOSYSTEM, // Special
      // Support (12 cards)
      CARD_IDS.OBSERVATION, CARD_IDS.OBSERVATION, CARD_IDS.OBSERVATION,
      CARD_IDS.BLOOM, CARD_IDS.BLOOM,
      CARD_IDS.HABITAT, CARD_IDS.HABITAT,
      CARD_IDS.MATERIALS, CARD_IDS.MATERIALS,
      CARD_IDS.TOOLS, CARD_IDS.TOOLS,
      CARD_IDS.GARDEN,
    ]
  },
  {
    name: 'Hybrid Master',
    description: 'Balanced deck with multiple win conditions',
    cards: [
      // Eco finisher (12 cards)
      CARD_IDS.SEED, CARD_IDS.SEED, CARD_IDS.SEED,
      CARD_IDS.SAPLING, CARD_IDS.SAPLING,
      CARD_IDS.TREE, CARD_IDS.TREE, CARD_IDS.TREE,
      CARD_IDS.FOREST, CARD_IDS.FOREST, CARD_IDS.FOREST,
      CARD_IDS.THRIVING_ECOSYSTEM, // Special
      // Tech finisher (14 cards)
      CARD_IDS.MATERIALS, CARD_IDS.MATERIALS, CARD_IDS.MATERIALS,
      CARD_IDS.TOOLS, CARD_IDS.TOOLS, CARD_IDS.TOOLS,
      CARD_IDS.BATTERY, CARD_IDS.BATTERY, CARD_IDS.BATTERY,
      CARD_IDS.SOLAR_PANEL, CARD_IDS.SOLAR_PANEL,
      CARD_IDS.SETTLEMENT, CARD_IDS.SETTLEMENT,
      CARD_IDS.CITY,
      // Wisdom core (14 cards)
      CARD_IDS.MEDITATION, CARD_IDS.MEDITATION, CARD_IDS.MEDITATION,
      CARD_IDS.PATIENCE, CARD_IDS.PATIENCE, CARD_IDS.PATIENCE,
      CARD_IDS.LOVE, CARD_IDS.LOVE, CARD_IDS.LOVE,
      CARD_IDS.ENGINEER, CARD_IDS.ENGINEER,
      CARD_IDS.NATURALIST, CARD_IDS.NATURALIST,
      CARD_IDS.COMMUNITY,
      // Support (5 cards)
      CARD_IDS.OBSERVATION, CARD_IDS.OBSERVATION,
      CARD_IDS.CURIOSITY, CARD_IDS.CURIOSITY,
      CARD_IDS.BLOOM,
    ]
  }
];

// Get a random deck for AI based on difficulty
export const getRandomAIDeck = (difficulty) => {
  let deckPool;
  
  switch (difficulty) {
    case 'easy':
      deckPool = AI_DECKS_EASY;
      break;
    case 'medium':
      deckPool = AI_DECKS_MEDIUM;
      break;
    case 'hard':
      deckPool = AI_DECKS_HARD;
      break;
    case 'expert':
      deckPool = AI_DECKS_EXPERT;
      break;
    default:
      deckPool = AI_DECKS_MEDIUM;
  }
  
  // Select random deck from pool
  const selectedDeck = deckPool[Math.floor(Math.random() * deckPool.length)];
  
  // Convert card IDs to full card objects
  const cards = selectedDeck.cards.map(id => {
    const card = cardLookup.get(id);
    if (!card) {
      console.warn(`AI Deck: Invalid card ID ${id}`);
      return null;
    }
    return { ...card };
  }).filter(Boolean);
  
  return {
    name: selectedDeck.name,
    description: selectedDeck.description,
    cards: cards
  };
};

// Load a specific AI deck by converting IDs to cards
export const loadAIDeck = (deckConfig) => {
  if (!deckConfig || !deckConfig.cards) {
    console.warn('Invalid AI deck config, using default');
    return loadDeck();
  }
  
  return deckConfig.cards;
};